import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FormCol extends Component {
  render() {
    var first = this.props.first;
    var last = this.props.last;
    var single = this.props.single;
    var third = this.props.third;
    var twothird = this.props.twothird;
    var scrolleable = this.props.scrolleable;
    var center = this.props.center;
    var cardList = this.props.cardList;
    var fixedHeight = this.props.fixedHeight;

    let className = cx({
      formCol: true,
      first: first,
      last: last,
      single: single,
      third: third,
      twothird: twothird,
      center: center,
      scrolleable: scrolleable,
      cardList: cardList,
      fixedHeight: fixedHeight,
    });

    return <div className={classnames(className)}>{this.props.children}</div>;
  }
}
